import { useCallback } from "react";
import Async from "react-select/async";
import { fetchApi } from "../../helpers/reactQueryApi";

interface MemberOption {
  value: string;
  label: string;
}

interface SimpleMemberSelectProps {
  onChange: (membershipId: string | null) => void;
  isDisabled?: boolean;
}

export default function SimpleMemberSelect({
  onChange,
  isDisabled,
}: SimpleMemberSelectProps) {
  const loadOptions = useCallback(
    async (input: string): Promise<MemberOption[]> => {
      const members = await fetchApi(`/members?q=${encodeURIComponent(input)}`);
      return members.map((m: { id: string; displayName: string }) => ({
        value: m.id,
        label: m.displayName,
      }));
    },
    [],
  );

  return (
    <Async<MemberOption, false>
      loadOptions={loadOptions}
      onChange={(option) => onChange(option ? option.value : null)}
      isDisabled={isDisabled}
      isClearable
      className="form-select-container"
      classNamePrefix="form-select"
      unstyled
      placeholder={I18n.t("js.member_select.placeholder")}
      loadingMessage={() => I18n.t("js.plugins.select2.searching")}
      noOptionsMessage={({ inputValue }) =>
        inputValue
          ? I18n.t("js.plugins.select2.no_match")
          : I18n.t("js.plugins.select2.enter_more_characters.one")
      }
    />
  );
}
